<template>
    <div>
        <div v-if="showTypePicker">
            <ul>
                <li
                    v-for="(type__value, type__key) in getPossiblePagesToCreate('header')"
                    v-bind:key="type__key"
                >
                    <a v-on:click.prevent="pickType(type__key)" href="#">{{ type__value }}</a>
                </li>
            </ul>
        </div>
        <div v-else>
            <app-text
                label="Name"
                :data-source="'tecpage.user.pages.' + listitemId + '.name'"
                required
                :maxlength="35"
            ></app-text>
            <app-text
                label="Slug"
                :data-source="'tecpage.user.pages.' + listitemId + '.slug'"
                disabled
                required
                :maxlength="255"
            ></app-text>
            <app-text
                label="SEO-Title"
                :data-source="'tecpage.user.pages.' + listitemId + '.title'"
                required
                :maxlength="255"
            ></app-text>
            <app-text
                label="SEO-Description"
                :data-source="'tecpage.user.pages.' + listitemId + '.description'"
                :maxlength="255"
            ></app-text>

            <app-checkbox
                label="Seite im Internet und in Suchmaschinen sichtbar"
                :data-source="'tecpage.user.pages.' + listitemId + '.accessible'"
            ></app-checkbox>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { OpenedRouteMixin } from '@/mixins/OpenedRouteMixin';
import Text from '@/components/fields/simple/Text.vue';
import Checkbox from '@/components/fields/simple/Checkbox.vue';

export default {
    data() {
        return {};
    },
    methods: {
        ...mapActions([
            'setProp',
            'forgetDifferInRoute',
            'addDifferInvalidField',
            'createDefaultModulesForPage'
        ]),
        async pickType(type) {
            let name = this.getPageDataByType(type).name,
                slug = this.generateSlug(name);
            await this.setProp({
                source: 'tecpage.user.pages.' + this.listitemId + '.name',
                value: name
            });
            await this.setProp({
                source: 'tecpage.user.pages.' + this.listitemId + '.type',
                value: type
            });
            await this.setProp({
                source: 'tecpage.user.pages.' + this.listitemId + '.menu_id',
                value: this.menuId
            });
            await this.setProp({
                source: 'tecpage.user.pages.' + this.listitemId + '.visible',
                value: true
            });
            await this.setProp({
                source: 'tecpage.user.pages.' + this.listitemId + '.accessible',
                value: true
            });
            await this.setProp({
                source: 'tecpage.user.pages.' + this.listitemId + '.pos',
                value: 999
            });
            await this.setProp({
                source: 'tecpage.user.pages.' + this.listitemId + '.slug',
                value: slug
            });
            await this.setProp({
                source: 'tecpage.user.pages.' + this.listitemId + '.title',
                value: name
            });
            await this.createDefaultModulesForPage({
                page_id: this.listitemId
            });
            await this.forgetDifferInRoute(this.openedRoute);
        }
    },
    computed: {
        ...mapGetters([
            'getProp',
            'getMenus',
            'getPossiblePagesToCreate',
            'generateSlug',
            'getPageDataByType',
            'getCurrentRouteQuery'
        ]),
        showTypePicker() {
            let type = this.getProp('tecpage.user.pages.' + this.listitemId + '.type');
            return type === undefined || type === null || type === '';
        }
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R075'),
            help: this.$helpers.uiText('R076'),
            removeText: this.$helpers.uiText('R077')
        });
        if (this.showTypePicker) {
            this.addDifferInvalidField({
                source: 'tecpage.user.pages.' + this.listitemId + '.type',
                route: this.openedRoute
            });
        }
    },
    props: {
        moduleId: String,
        listitemId: String,
        menuId: String
    },
    components: {
        'app-text': Text,
        'app-checkbox': Checkbox
    },
    mixins: [OpenedRouteMixin]
};
</script>
